const totalJobs = myGlobalData.totalJobs; // eslint-disable-line
if (totalJobs > 0) {
  $('a.nav-job-total, li.nav-job-total > a').append('<span class="job-count">'+totalJobs+'</span>');
  $('a.nav-job-total').parent().addClass('has-jobs');
}
